import styles from "./ExpenseFilter.module.css";
const ExpenseFilter = (props) => {
  const changeFilteredYearHandler = (event) => {
    props.onChangeFilterYear(event.target.value);
  };

  return (
    <section
      className={styles["expenses-filter"]}
    >
      <h2
        id={
          styles["expenses-filter__filterByYear"]
        }
      >
        Filter by year
      </h2>
      <select
        onChange={changeFilteredYearHandler}
        id={styles["expenses-filter__select"]}
      >
        <option value="2022">2022</option>
        <option value="2021">2021</option>
        <option value="2020">2020</option>
        <option value="2019">2019</option>
        <option value="2018">2018</option>
      </select>
    </section>
  );
};

export default ExpenseFilter;
